<section>
  <div class="mb-2">
    <form class="needs-validation" novalidate [formGroup]="formClient">
      <div class="row">
        <div class="col-lg-8 col-8">
          <app-custom-input-text formControlName="document" [labelText]="'Documento'" [required]="true"
            (onChangeTextOnBlur)="getDigitVerification()"></app-custom-input-text>
        </div>
        <div class="col-lg-4 col-4">
          <app-custom-input-number formControlName="digitVerification" [labelText]="'D. Verif.'"
            [required]="true"></app-custom-input-number>
        </div>
        <div class="col-lg-8 col-8">
          <app-custom-input-text formControlName="document2" [labelText]="'Documento 2'"
            (onChangeTextOnBlur)="getDigitVerification2()"></app-custom-input-text>
        </div>
        <div class="col-lg-4 col-4">
          <app-custom-input-number formControlName="digitVerification2"
            [labelText]="'D. Verif. 2'"></app-custom-input-number>
        </div>
      </div>
    </form>
  </div>
</section>
<section>
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-end mt-3 gap-2">
      <app-custom-button [title]="'Guardar'" [label]="'Guardar'" (onClick)="send()"></app-custom-button>
    </div>
  </div>
</section>